// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"1647a44d","130":"a5d2e086","190":"b36aba32","460":"8675c67b","466":"b8dcdb4c","755":"bfec1796","787":"fa235f9c","798":"a1743e52","852":"d36b4926","875":"311255e4","882":"717bd880"}[chunkId] + ".chunk.js";
};